export function CheckoutSection() {
  return (
    <section
      id="checkout"
      className="relative py-16 sm:py-24 lg:py-32 overflow-hidden bg-gradient-to-br from-emerald-50 via-cyan-50 to-teal-50"
    >
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-emerald-300/30 to-cyan-300/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-teal-300/30 to-emerald-300/30 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mx-auto mb-8 sm:mb-12">
          <div className="bg-gradient-to-r from-red-500 via-orange-500 to-red-500 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 shadow-2xl border-2 sm:border-4 border-white animate-pulse">
            <div className="text-center space-y-3 sm:space-y-4">
              <div className="flex items-center justify-center gap-1 sm:gap-2 mb-2">
                <i className="ri-alarm-warning-line text-white text-xl sm:text-2xl lg:text-3xl"></i>
                <h3 className="text-base sm:text-xl lg:text-2xl font-extrabold text-white">⚡ OFERTA EXPIRA EN:</h3>
                <i className="ri-alarm-warning-line text-white text-xl sm:text-2xl lg:text-3xl"></i>
              </div>

              <div className="flex justify-center gap-2 sm:gap-3 lg:gap-4">
                <div className="bg-white/20 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 min-w-[70px] sm:min-w-[90px] lg:min-w-[120px] border border-white/30 sm:border-2">
                  <div className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white mb-1 sm:mb-2">59</div>
                  <div className="text-white text-[10px] sm:text-xs lg:text-sm font-bold uppercase tracking-wider">Minutos</div>
                </div>
                <div className="flex items-center">
                  <span className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white">:</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 min-w-[70px] sm:min-w-[90px] lg:min-w-[120px] border border-white/30 sm:border-2">
                  <div className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white mb-1 sm:mb-2">52</div>
                  <div className="text-white text-[10px] sm:text-xs lg:text-sm font-bold uppercase tracking-wider">Segundos</div>
                </div>
              </div>

              <div className="space-y-1 sm:space-y-2 pt-2">
                <p className="text-white font-bold text-xs sm:text-base lg:text-lg">🔥 Solo quedan 7 cupos disponibles a este precio</p>
                <p className="text-white/90 text-xs sm:text-sm lg:text-base">⚠️ Después de esto, el precio volverá a $47</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-gray-900 mb-3 sm:mb-4 lg:mb-6 px-4">
            Comienza tu transformación <span className="bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">hoy mismo</span>
          </h2>
          <p className="text-sm sm:text-base lg:text-xl text-gray-600 leading-relaxed px-4">
            Acceso completo a todos los cursos, comunidad y actualizaciones
          </p>
        </div>

        <div className="flex justify-center max-w-2xl mx-auto px-4">
          <div className="relative rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 cursor-pointer transition-all duration-300 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 shadow-2xl hover:shadow-emerald-500/50 hover:scale-105 w-full">
            <div className="absolute -top-3 sm:-top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 px-4 sm:px-6 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold whitespace-nowrap shadow-lg animate-pulse">
              🔥 MÁS POPULAR
            </div>

            <div className="text-center space-y-4 sm:space-y-6">
              <div>
                <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2 text-white">Acceso de Por Vida</h3>
                <p className="text-xs sm:text-sm lg:text-base text-emerald-100">Pago único • Sin renovaciones</p>
              </div>

              <div className="py-4 sm:py-6">
                <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2">
                  <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white/60 line-through">$47</span>
                  <span className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white">$20</span>
                </div>
                <p className="text-emerald-100 text-xs sm:text-sm lg:text-base">Pago único • Acceso ilimitado</p>
              </div>

              <ul className="space-y-3 sm:space-y-4 text-left">
                <li className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-sm sm:text-base lg:text-lg">Acceso a todos los cursos</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-sm sm:text-base lg:text-lg">Actualizaciones de por vida</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-sm sm:text-base lg:text-lg">Comunidad privada en Skool</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-sm sm:text-base lg:text-lg">Clases en vivo mensuales</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-sm sm:text-base lg:text-lg">Soporte 24/7</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-sm sm:text-base lg:text-lg">Soporte de vida</span>
                </li>
              </ul>

              <a
                href="https://pay.hotmart.com/I103812749W?off=gkmu5rxa&checkoutMode=10"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full px-4 sm:px-6 lg:px-8 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold text-xs sm:text-sm lg:text-base xl:text-lg bg-gradient-to-r from-yellow-400 via-orange-400 to-red-500 text-white hover:shadow-2xl hover:shadow-orange-500/60 transition-all hover:scale-110 shadow-xl cursor-pointer animate-pulse border-2 sm:border-4 border-white/50 text-center leading-tight"
              >
                🔥 ACCEDER AHORA CON PRECIO DE DESCUENTO 🔥
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
